import { pageRoutes } from "@/src/constants/pageRoutes";
import { lazy } from "react";

export const routes = [
  { path: pageRoutes.home, component: lazy(() => import("../pages/Home")) },
  {
    path: pageRoutes.register,
    component: lazy(() => import("../pages/Register")),
  },
  { path: pageRoutes.login, component: lazy(() => import("../pages/Login")) },
  {
    path: pageRoutes.patientLogin,
    component: lazy(() => import("../pages/PatientLogin")),
  },
  {
    path: pageRoutes.forgotPassword,
    component: lazy(() => import("../pages/ForgotPassword")),
  },
  {
    path: pageRoutes.checkInChat,
    component: lazy(() => import("../pages/CheckInChat")),
  },
  {
    path: pageRoutes.checkInSpeak,
    component: lazy(() => import("../pages/CheckInSpeak")),
  },
  {
    path: pageRoutes.dashboard,
    component: lazy(() => import("../pages/Dashboard")),
  },
  {
    path: pageRoutes.doctorpatients,
    component: lazy(() => import("../pages/DoctorDashboardPatientList")),
  },
  {
    path: pageRoutes.dashboardPatient,
    component: lazy(() => import("../pages/DashboardPatientRecords")),
  },
  {
    path: pageRoutes.scheduleAppointment,
    component: lazy(() => import("../pages/ScheduleAppointment")),
  },
  {
    path: pageRoutes.viewAppointments,
    component: lazy(() => import("../pages/ViewAppointment")),
  },
  { path: pageRoutes.info, component: lazy(() => import("../pages/Info")) },
  {
    path: pageRoutes.landing,
    component: lazy(() => import("../pages/Landing")),
  },
  {
    path: pageRoutes.docaideMindChat,
    component: lazy(() => import("../pages/DocaideMindChat")),
  },
  {
    path: pageRoutes.docaideMindSpeak,
    component: lazy(() => import("../pages/DocaideMindSpeak")),
  },
  {
    path: pageRoutes.therapyChat,
    component: lazy(() => import("../pages/DocaideTherapyChat")),
  },
  {
    path: pageRoutes.therapySpeak,
    component: lazy(() => import("../pages/DocaideTherapySpeak")),
  },
  {
    path: pageRoutes.selectUser,
    component: lazy(() => import("../pages/SelectUserPage")),
  },
  {
    path: pageRoutes.dashboardPatientList,
    component: lazy(() => import("../pages/DashboardPatientList")),
  },
  {
    path: pageRoutes.adminDashboardAppointmentList,
    component: lazy(() => import("../pages/AdminDashboardAppointmentList")),
  },
  {
    path: pageRoutes.adminDashboardHospitalList,
    component: lazy(() => import("../pages/AdminDashboardHospitalList")),
  },
  {
    path: pageRoutes.providerList,
    component: lazy(() => import("../pages/ProviderList")),
    layout: "modern",
    title: "Appointment",
  },
  {
    path: pageRoutes.adminDashboardPatientList,
    component: lazy(() => import("../pages/AdminDashboardPatientList")),
  },
  {
    path: pageRoutes.docaideLaunch3,
    component: lazy(() => import("../pages/DocaideLaunch3")),
  },
  {
    path: pageRoutes.emergency,
    component: lazy(() => import("../pages/Emergency")),
  },
  {
    path: pageRoutes.newPatient,
    component: lazy(() => import("../pages/NewPatient")),
  },
  {
    path: pageRoutes.adminDashboardNewPatient,
    component: lazy(() => import("../pages/AdminDashboardNewPatient")),
  },
  {
    path: pageRoutes.adminDocaideLaunch2,
    component: lazy(() => import("../pages/AdminDocaideLaunch2")),
  },
  {
    path: pageRoutes.adminDocaideLaunch3,
    component: lazy(() => import("../pages/AdminDocaideLaunch3")),
  },
  {
    path: pageRoutes.adminDashboardEditPatient,
    component: lazy(() => import("../pages/AdminDashboardEditPatient")),
  },
  {
    path: pageRoutes.editPatient,
    component: lazy(() => import("../pages/EditPatient")),
  },
  {
    path: pageRoutes.frontDeskLogin,
    component: lazy(() => import("../pages/FrontDeskLogin")),
  },
  {
    path: pageRoutes.patientWelcome,
    component: lazy(() => import("../pages/PatientWelcome")),
  },
  {
    path: pageRoutes.reduxPage,
    component: lazy(() => import("../pages/ReduxPage")),
  },
  //{
  //path: pageRoutes.patientDetails,
  //component: lazy(() => import("../pages/PatientDetails")),
  //},
  {
    path: pageRoutes.viewAppointmentDetails,
    component: lazy(() => import("../pages/ViewAppointmentDetails")),
  },
  {
    path: pageRoutes.updatePatientDetails,
    component: lazy(() => import("../pages/patient/UpdatePatientDetails")),
  },
  {
    path: pageRoutes.addNewPatient,
    component: lazy(() => import("../pages/patient/AddNewPatient")),
  },
  {
    path: pageRoutes.nurseList,
    component: lazy(() => import("../pages/NurseList")),
  },
  {
    path: pageRoutes.nurseAppointmentList,
    component: lazy(() => import("../pages/nurse/NurseAppointmentList")),
  },
  {
    path: pageRoutes.nursePatientRecord,
    component: lazy(() => import("../pages/nurse/NursePatientRecord")),
  },
  //{
  //path: pageRoutes.nursePatientVitals,
  //component: lazy(() => import("../pages/nurse/NursePatientVitals.jsx")),
  //},
  //{
  //path: pageRoutes.nursePatientPharmacy,
  //component: lazy(() => import("../pages/nurse/NursePatientPharmacy")),
  //},
  {
    path: pageRoutes.admissionForm,
    component: lazy(() => import("../pages/AdmissionForm")),
    layout: "modern",
    title: "Patient Management",
  },
];
